<template>
  <el-select
    size="small"
    placeholder="请选择"
    multiple
    :value="value"
    @change="handleChange"
    v-model="selected"
  >
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { userList } from '@/service/getData'
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    code: String,
  },
  watch: {
    value: function (n, o) {
      this.selected = n || []
    },
  },
  data() {
    return {
      options: [],
      selected: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      let res = await userList({
        page: 0,
        size: 40,
        status: 1,
        auth_code: this.code,
      })
      this.options = res.data.list
    },
    handleChange(e) {
      this.$emit('input', e)
    },
  },
}
</script>